import React, { useEffect, useState } from "react";
import Joi from "joi-browser";
import { useDispatch } from "react-redux";
import useForm from "../../hooks/useForm";
import { authStart, getUserType } from "../../app/store/auth";

const schema = {
  validId: Joi.string().required().label("Valid ID"),
};

const LoginStep1 = ({
  type,
  validId,
  userError,
  handleStep1,
  handleAdLogin,
  interactionInProgress,
}) => {
  const { data, setData, errors, setErrors, renderEnterInput, validate, handleSubmit } =
    useForm(schema, {});

  const dispatch = useDispatch();
  const [isProcessing, setIsProcessing] = useState(false);

  // componentDidMount: seed validId from props if provided
  useEffect(() => {
    if (validId) {
      setData((prev) => ({ ...prev, validId }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // componentWillReceiveProps: surface an external user error on the field
  useEffect(() => {
    if (userError !== undefined) {
      setErrors((prev) => ({ ...prev, validId: userError }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userError]);

  const doSubmit = async () => {
    setIsProcessing(true);
    const newData = { ...data };

    try {
      const startResult = await dispatch(
        authStart(newData["validId"], "workbench")
      );

      localStorage.setItem("challengeId", startResult.challengeId);

      const result = await dispatch(getUserType(newData["validId"]));
      newData["userType"] = result;
      localStorage.setItem("userType", newData["userType"]);
      handleStep1(newData);
    } catch (err) {
      const res = err.response;
      let isInactive = res?.data === "inactive" || res?.data?.message === "inactive";

      if (!isInactive) {
        try {
          await dispatch(getUserType(newData["validId"]));
        } catch (typeErr) {
          if (typeErr.response?.data === "inactive") {
            isInactive = true;
          }
        }
      }

      localStorage.removeItem("challengeId");

      const newErrors = { ...errors };
      if (isInactive)
        newErrors["validId"] =
          "Your account has been deactivated, please contact system administrator systemadmin@workfinity.com";
      else newErrors["validId"] = "Invalid Id";

      setErrors(newErrors);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <React.Fragment>
      {renderEnterInput("validId", "Enter Your Valid ID", "text", doSubmit)}
      {/* <div className="form-group">
        <label htmlFor="validId" className="form-control-label">
          Enter Your Valid ID
        </label>
        <input
          type="text"
          className="form-control"
          name="validId"
          id="validId"
          placeholder="Enter Your Valid ID"
        />
      </div> */}
      <button
        type="submit"
        className="wf-login-btn-primary"
        style={{
          backgroundColor: `${type === "admin" ? "#298607" : "#2b62a1"}`,
          color: "white",
        }}
        disabled={Boolean(validate()) || isProcessing}
        onClick={(e) => handleSubmit(e, doSubmit)}
      >
        {isProcessing ? (
          <i className="fa fa-refresh fa-spin mr-2" aria-hidden="true"></i>
        ) : null}
        {isProcessing ? "Processing..." : "Next"}
      </button>
      <button
        className="wf-login-btn-ms mt-3"
        onClick={handleAdLogin}
        disabled={interactionInProgress || isProcessing}
      >
        {interactionInProgress ? (
          <i className="fa fa-circle-o-notch fa-spin mr-2"></i>
        ) : (
          <i className="fa fa-windows" style={{ color: "#00a1f1" }}></i>
        )}
        Sign In With Microsoft
      </button>
    </React.Fragment>
  );
};

export default LoginStep1;
